import { Matches, IsNotEmpty, IsString } from 'class-validator';
import { Transform, TransformFnParams } from 'class-transformer';

export class ChangePasswordDTO {
  @IsNotEmpty()
  @IsString()
  @Transform(({ value }: TransformFnParams) => value?.trim())
  public oldPassword!: string;

  @Matches(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
    { message: 'min 8 characters, min 1 upper/lower/number/spec-char' })
  public newPassword!: string;
}
